import { Component, Input, AfterViewInit, ViewChild, ViewChildren, Output, EventEmitter, OnInit, ElementRef } from '@angular/core';
import { NgForm, NgModel } from '@angular/forms';

import { AuthService, ConfigService, FormsUtilsService, ButtonLoader } from '../../../core';
import { ConfigEmpresa } from '../../configuracoes/app/empresa';
import { ConfigCliente } from '../../configuracoes/app/cliente';
import { isModoCentralCompraCadastro } from '../../../models/modo-central-compra';
import { Pessoa } from '../pessoa';
import { PessoaTipo, pessoaFisica, pessoaJuridica, pessoaCentralCompras, isTipoPessoaFisica, isTipoPessoaJuridica, isTipoPessoaFisicaOuJuridica, isTipoPessoaCentralCompras } from '../tipo';
import { pessoaTipoCadastro } from '../pessoa-tipo-cadastro';
import { isClienteCadastroProspect } from '../cliente/cadastro';
import { isClienteSituacaoCongelado, isClienteSituacaoBaixado, isClienteSituacaoPreBaixado } from '../cliente/situacao';
import { RepresentanteSituacao } from '../representante/situacao';
import { TransportadoraSituacao } from '../transportadora/transportadora-situacao';
import { Usuario } from '../../usuario/usuario';
import { isClienteCadastroBaixado, isClienteCadastroCliente } from '../cliente/cadastro';
import { MotivoPerdaVenda } from '../../motivo-perda-venda';
import { isCadastroCliente } from 'app/home/tipo-classificacao/cadastro';


@Component({
    selector: 'sgt-pessoa-form',
    templateUrl: './pessoa-form.component.html',
    styleUrls: ['./pessoa-form.component.less']
})
export class PessoaFormComponent implements OnInit, AfterViewInit {
    configEmpresa: ConfigEmpresa;
    configCliente: ConfigCliente;
    isAdministrador: boolean;

    // Permissões do usuários
    usuarioPodeSalvarCnpjCpfInvalido: boolean; // Se o usuário pode salvar o CNPJ/CPF inválido
    ignorarCnpjCpfInvalido = false; // Se deve ignorar o erro de CNPJ/CPF inválido

    @Input() entity: Pessoa;
    @Input() parentForm: NgForm;
    @Input() canEdit = true;
    @Input() editMode: boolean;
    @Input() dataCadastro: Date;
    @Input() tipoCadastro: number;
    @Input() isClienteCnpjCpfRequired: boolean;
    @Input() isNomeFantasiaRequired = true;
    @Input() isDataFundacaoRequired = false;
    @Input() isConsultandoCnpj = false;
    /** Se pode editar o tipo da pessoa */
    @Input() canEditTipo = true;
    @Input() canEditCnpjCpf = true;
    @ViewChildren(NgModel) private controls: NgModel[];

    /** Ao alterar o tipo da pessoa */
    @Output() tipoChange = new EventEmitter<number>();
    /** Ao alterar a flag de exterior */
    @Output() exteriorChange = new EventEmitter<boolean>();
    /** Emite evento para validar o CNPJ/CPF  */
    @Output() validarCnpjCpfCadastrado = new EventEmitter<any>();

    // Cliente
    @Input() clienteCadastro: number;
    @Input() clienteCadastroLabel: string;
    @Input() clienteSituacao: number;
    @Input() clienteSituacaoLabel: string;
    @Input() clienteRevisaoPendente: boolean;
    @Input() clienteDataUltimaRevisao: Date;
    @Input() clienteUsuarioUltimaRevisao: Usuario;
    @Input() clienteDataCongelamento: Date;
    @Input() clienteUsuarioCongelamento: Usuario;
    @Input() clienteMotivoCongelamento: MotivoPerdaVenda;
    @Input() clienteJustificativaCongelamento: string;
    @Input() clienteDataPreBaixa: Date;
    @Input() clientePreBaixaManual: boolean;
    @Input() clienteUsuarioPreBaixa: Usuario;
    @Input() clienteDataBaixa: Date;
    @Input() clienteBaixaManual: boolean;
    @Input() clienteUsuarioBaixa: Usuario;
    @Input() clienteMotivoBaixa: string;

    // Represetante
    @Input() representanteSituacoes: RepresentanteSituacao[];
    @Input() representanteSituacao: number;
    @Output() representanteSituacaoChange = new EventEmitter<number>();
    // Transportadora
    @Input() transportadoraSituacoes: TransportadoraSituacao[];
    @Input() transportadoraSituacao: number;
    @Output() transportadoraSituacaoChange = new EventEmitter<number>();

    tipos: PessoaTipo[];

    @ViewChild('form') form: NgForm;
    @ViewChild('cnpjCpfInput') cnpjCpfInput: ElementRef;
    @ViewChild('nomeInput') nomeInput: ElementRef;

    constructor(private authService: AuthService,
                private configService: ConfigService,
                private formsUtilsService: FormsUtilsService) { }

    ngOnInit() {
        this.configEmpresa = this.configService.getEmpresa();
        this.configCliente = this.configService.getCliente();
        this.isAdministrador = this.authService.isAdministrador();

        // Permissões do usuários
        this.usuarioPodeSalvarCnpjCpfInvalido = this.authService.podeSalvarCnpjCpfInvalido();

        this.createTipos();
    }

    /** Seta foco no input do CNPJ/CPF */
    setFocusCnpjCPF() {
        jQuery(this.cnpjCpfInput?.nativeElement).trigger('focus');
    }

    /** Seta foco no input do nome */
    setFocusNome() {
        jQuery(this.nomeInput?.nativeElement).trigger('focus');
    }

    ngAfterViewInit() {
        // Adiciona os controls da pessoa no parentForm
        // this.controls.forEach((control: NgModel) => {
        //     this.parentForm.addControl(control);
        // });
    }

    /** Cria os tipos de pessoas */
    private createTipos() {
        this.tipos = [];
        // Física
        this.tipos.push(pessoaFisica);
        // Jurídica
        this.tipos.push(pessoaJuridica);
        // Cental de Compras
        if (isModoCentralCompraCadastro(this.configEmpresa.modoCentralCompra)) {
            this.tipos.push(pessoaCentralCompras);
        }
    }

    /** Verifica se o tipo da pessoa é Fisica */
    isTipoPessoaFisica(): boolean {
        return isTipoPessoaFisica(this.entity?.tipo);
    }

    /** Verifica se o tipo da pessoa é Juridica */
    isTipoPessoaJuridica(): boolean {
        return isTipoPessoaJuridica(this.entity?.tipo);
    }

    /** Verifica se o tipo da pessoa é Fisica ou Juridica */
    isTipoPessoaFisicaOuJuridica(): boolean {
        return isTipoPessoaFisicaOuJuridica(this.entity?.tipo);
    }

    /** Verifica se o tipo da pessoa é Central de Compras */
    isTipoPessoaCentralCompras(): boolean {
        return isTipoPessoaCentralCompras(this.entity?.tipo);
    }

    /** Obtem o label do CNPJ/CPF pelo tipo da pessoa selecionado */
    getLabelCnpjCpfByTipo() {
        // Sem tipo
        if (!this.entity || !this.entity.tipo) {
            return 'CNPJ / CPF';
        }
        // Física
        if (this.isTipoPessoaFisica()) {
            return 'CPF';
        }
        // Júridica
        if (this.isTipoPessoaJuridica()) {
            return 'CNPJ';
        }

        // Padrão
        return 'CNPJ / CPF';
    }

    /** Verifica se o usuário pode cadastrar clientes do exterior */
    podeCadastrarClienteExterior(): boolean {
        return this.configEmpresa?.exportadora && this.authService.podeCadastrarClienteExterior();
    }

    /** Verifica se a empresa é exportadora */
    isEmpresaExportadora(): boolean {
        if (!this.configEmpresa) {
            return false;
        }
        return this.configEmpresa.exportadora;
    }

    /** Se exibe o código númerico */
    isShowCodigo(): boolean {
        return this.tipoCadastro && this.tipoCadastro === pessoaTipoCadastro.representante
    }

    /** Verifica se a pessoa é um cliente */
    isCliente(): boolean {
        return this.tipoCadastro && this.tipoCadastro === pessoaTipoCadastro.cliente;
    }

    /** Verifica se é um cliente com cadastro cliente */
    isClienteCadastroCliente(): boolean {
        return isClienteCadastroCliente(this.clienteCadastro);
    }

    /** Verifica se é um cliente prospect */
    isClienteProspect() {
        return isClienteCadastroProspect(this.clienteCadastro);
    }

    /** Verifica se é um cliente congelado */
    isClienteCongelado(): boolean {
        return this.isClienteCadastroCliente() && isClienteSituacaoCongelado(this.clienteSituacao);
    }

    /** Verifica se é um cliente pré-baixado */
    isClientePreBaixado(): boolean {
        return isClienteCadastroBaixado(this.clienteCadastro) && isClienteSituacaoPreBaixado(this.clienteSituacao);
    }

    /** Verifica se é um cliente baixado */
    isClienteBaixado(): boolean {
        return isClienteCadastroBaixado(this.clienteCadastro) && isClienteSituacaoBaixado(this.clienteSituacao);
    }

    /** Verifica se a pessoa é um representante */
    isRepresentante(): boolean {
        return this.tipoCadastro && this.tipoCadastro === pessoaTipoCadastro.representante;
    }

    /** Verifica se a pessoa é uma transportadora */
    isTransportadora(): boolean {
        return this.tipoCadastro && this.tipoCadastro === pessoaTipoCadastro.transportadora;
    }

    /** Se exibe o código de integração */
    isShowcodigoIntegracaoErp(): boolean {
        return this.isCliente();
    }

    /** Verifica se deve exibir a data e responsável da última revisão do cliente */
    isShowUltimaRevisao(): boolean {
        return this.isCliente() && this.editMode && !this.clienteRevisaoPendente;
    }

    /** Ao sair do campo do CNPJ/CPF emitimos o evento para validar se o CNPJ/CPF já está cadastrado */
    onBlurCnpjCpf() {
        this.validarCnpjCpfCadastrado.emit();
    }

    /** Verifica se o CNPJ/CPF é obrigatório */
    isCnpjCpfRequired(): boolean {
        // Prospect
        if (this.isClienteProspect()) {
            return this.configCliente?.obrigarCnpjCpfProspect;
        }

        // Somente quando for uma pessoa do tipo Física ou Juridica que não seja do exterior
        return this.isTipoPessoaFisicaOuJuridica() && !this.entity.exterior;
    }

    /** Verifica se deve validar o CNPJ/CPF */
    mustValidateCnpjCpf(): boolean {
        if (!this.entity) {
            return true;
        }

        // Se o usuário poder salvar com o CNPJ/CPF e estiver selecionado para ignorar o erro de validação, então não deve validar
        if (this.usuarioPodeSalvarCnpjCpfInvalido && this.ignorarCnpjCpfInvalido) {
            return false;
        }

        // Se não for uma pessoa Física ou Juridica então não deve validar
        if (!this.isTipoPessoaFisicaOuJuridica()) {
            return false;
        }

        // Se for do exterior, então não deve validar
        if (this.entity.exterior) {
            return false;
        }

        return true;
    }

    /** Ao alterar o tipo */
    onChangeTipo(tipo: number) {
        this.entity.tipo = tipo;
        this.tipoChange.emit(this.entity.tipo);
    }

    /** Ao alterar a flag de exterior */
    onChangeExterior(exterior: boolean) {
        this.entity.exterior = exterior;
        this.exteriorChange.emit(this.entity.exterior);
    }

    /** Ao alterara a situação de um representante */
    onChangeRepresentanteSituacao(situacao: number) {
        this.representanteSituacao = situacao;
        this.representanteSituacaoChange.emit(situacao);
    }

    /** Ao alterara a situação de uma transportadora */
    onChangeTransportadoraSituacao(situacao: number) {
        this.transportadoraSituacao = situacao;
        this.transportadoraSituacaoChange.emit(situacao);
    }

    /** Valida se pode realizar o save */
    validateSave(): boolean {
        this.formsUtilsService.makeAllFieldsDirty(this.form);

        // Validando o form
        if (this.form?.invalid) {
            this.formsUtilsService.showMsgFormInvalid();
            return false;
        }

        return true;
    }
}
